/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Club_RemovedInputs */

const en_us2_club_removed = /** @type {(inputs: Club_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You were removed from this club.`)
};

const pt_br2_club_removed = /** @type {(inputs: Club_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você foi removido deste clube.`)
};

const es_419_club_removed = /** @type {(inputs: Club_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te quitaron de este club.`)
};

const pt_pt2_club_removed = /** @type {(inputs: Club_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foste removido deste clube.`)
};

const fr_fr2_club_removed = /** @type {(inputs: Club_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu ne fais plus partie de ce club.`)
};

const de_de2_club_removed = /** @type {(inputs: Club_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du wurdest aus diesem Club entfernt.`)
};

const it_it2_club_removed = /** @type {(inputs: Club_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei stato rimosso da questo club.`)
};

/**
* | output |
* | --- |
* | "You were removed from this club." |
*
* @param {Club_RemovedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const club_removed = /** @type {((inputs?: Club_RemovedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Club_RemovedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_club_removed(inputs)
	if (locale === "es-419") return es_419_club_removed(inputs)
	if (locale === "pt-PT") return pt_pt2_club_removed(inputs)
	if (locale === "fr-FR") return fr_fr2_club_removed(inputs)
	if (locale === "de-DE") return de_de2_club_removed(inputs)
	if (locale === "it-IT") return it_it2_club_removed(inputs)
	return en_us2_club_removed(inputs)
});
export { club_removed as "club.removed" }